import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  organizationTree: {},
  organizations: [],
  brands: [],
  countries: [],
  stores: [],
  campaignTypes: [],
  isRefreshCountry: true,
  isRefreshOrganizationTree: true,
  isRefreshBrands: true,
  isRefreshOrganizations: true,
  isRefreshStores: true,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizationTree(state, action) {
      state.organizationTree = { ...action.payload };
      state.isRefreshOrganizationTree = false;
    },
    setOrganizations(state, action) {
      state.organizations = [...action.payload];
      state.isRefreshOrganizations = false;
      state.isRefreshOrganizationTree = true;
    },
    setBrands(state, action) {
      state.brands = [...action.payload];
      state.isRefreshBrands = false;
      state.isRefreshOrganizationTree = true;
    },
    setCountries(state, action) {
      state.countries = [...action.payload];
      state.isRefreshCountry = false;
    },
    setStores(state, action) {
      state.stores = [...action.payload];
      state.isRefreshStores = false;
      state.isRefreshOrganizationTree = true;
    },
    setCampaignTypes(state, action) {
      state.campaignTypes = [...action.payload];
    },
    setIsRefreshOrganizations(state, action) {
      state.isRefreshOrganizations = action.payload;
    },
    setIsRefreshBrands(state, action) {
      state.isRefreshBrands = action.payload;
    },
    setIsRefreshCountry(state, action) {
      state.isRefreshCountry = action.payload;
    },
    setIsRefreshStores(state, action) {
      state.isRefreshStores = action.payload;
    },
    setIsRefreshOrganizationTree(state, action) {
      state.isRefreshOrganizationTree = action.payload;
    },
  },
});

export const {
  setOrganizationTree,
  setOrganizations,
  setBrands,
  setCountries,
  setStores,
  setCampaignTypes,
  setIsRefreshOrganizations,
  setIsRefreshBrands,
  setIsRefreshCountry,
  setIsRefreshStores,
  setIsRefreshOrganizationTree,
} = organizationSlice.actions;
export default organizationSlice.reducer;
